import React from 'react';
import { Navigate } from 'react-router-dom';
import Loader from "../components/atoms/Loader";
import { useMerchant } from "./MerchantContext";

export const MerchantGuard = ({ children }) => {
  const { merchant, loading } = useMerchant();

  if (loading) {
    return (
      <div className="page-layout">
        <Loader />
      </div>
    );
  }

  if (!merchant) {
    return <Navigate to="/forbidden" />;
  }
  
  // Use merchant.id as key to force complete re-render when merchant changes
  return (
    <div key={merchant.id}>
      {children}
    </div>
  );
};
